module.exports = __webpack_public_path__ + "static/media/no_img.625d1aff.jpg";